import { useLabels } from 'labels/hooks/useLabels/useLabels'

import text from 'fukku/styles/texts.module.scss'
import styles from './StoreLocatorTitle.module.scss'

export const StoreLocatorTitle = () => {
	const { t } = useLabels()

	return (
		<h2 className={`${text.titleXL} ${styles.storeLocatorHeader}`}>
			{t('storeLocator.search.title')}
		</h2>
	)
}
